import { Form, Input, Grid, Select, Field } from "@alifd/next";
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
const regexp = new RegExp(/^[a-zA-Z][0-9a-zA-Z_]{0,49}$/);
const AddDep = forwardRef((props: any, ref) => {
    const { rpcAssembly, rpcModule, options, ...otherProps } = props;
    const [dataSource, setDataSource] = useState({});
    const [ops, setOps] = useState<any>([]);
    let contextComp: any = {};
    contextComp.setState = (data: any) => {
        setDataSource(data);
    }
    const Option = Select.Option;
    const fieldRef = useRef(new Field(contextComp));

    useEffect(() => {
        setOps(options);
        fieldRef.current.reset();
        fieldRef.current.setValue('Active', true);
    }, []);
    useImperativeHandle(ref, () => {
        let proxy: any = {};
        Object.defineProperty(proxy, 'dataSource', {
            get() {
                let result: any = fieldRef.current.getValues();
                return result;
            }
        });
        proxy.validate = () => {
            return new Promise((resolve, reject) => {
                try {
                    fieldRef.current.validate((errors: any, values: any) => {
                        resolve({ errors, values });
                    });
                } catch (error) {
                    reject(error);
                }
            });
        }
        return proxy;
    }, []);

    return (
        <Form field={fieldRef.current} className="bef-custom-dep">
            <Grid.Row gutter="12">
                <Grid.Col>
                    <Form.Item className="custom-form-control" required label="部门编号" name="Id" pattern={regexp} patternMessage={'编号必须以字母开始，可以由字母、数字、下划线组成；且在50字符以内！'}>
                        <Input />
                    </Form.Item>
                </Grid.Col>
                <Grid.Col>
                    <Form.Item className="custom-form-control" required label="部门名" name="Name">
                        <Input />
                    </Form.Item>
                </Grid.Col>
            </Grid.Row>
            <Grid.Row gutter="12">
                <Grid.Col>
                    <Form.Item className="custom-form-control" label="上级部门" name="ParentId">
                        <Select
                            style={{ width: '100%' }}
                            hasClear>
                            {ops.map((op: any) => {
                                return <Option key={op.Id} value={op.Id}>{op.Name}</Option>
                            })}
                        </Select>
                    </Form.Item>
                </Grid.Col>
                <Grid.Col>
                    {/* <Form.Item label="是否激活" name="Active">
                        <Switch autoWidth />
                    </Form.Item> */}
                </Grid.Col>
            </Grid.Row>
        </Form>
    );
});
export default AddDep;